import { InviteSection } from "../components/InviteSection";
import { MembersList } from "../components/MembersList";
import { useAuth } from "../context/auth";

export function TeamSettingsPage() {
	const { hasPermission } = useAuth();

	if (!hasPermission("settings", "read")) {
		return (
			<div className="max-w-2xl mx-auto mt-8">
				<p
					className="text-sm text-gray-600"
					data-testid="team-settings-no-access"
				>
					You don't have access to this page.
				</p>
			</div>
		);
	}

	return (
		<div className="max-w-3xl mx-auto mt-8" data-testid="team-settings-page">
			<h1 className="text-2xl font-bold text-gray-900 mb-6">Team</h1>

			<section className="bg-white border border-gray-200 rounded-lg p-6 mb-6">
				<h2 className="text-lg font-semibold text-gray-900 mb-4">Members</h2>
				<MembersList />
			</section>

			{hasPermission("members", "invite") && (
				<section className="bg-white border border-gray-200 rounded-lg p-6">
					<InviteSection />
				</section>
			)}
		</div>
	);
}
